import $ from 'jquery'
import noUiSlider from "nouislider";
export default {
    init() {
        // JavaScript to be fired on the home page
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS

      var calcContainer =  $('#depositcalc-container'),
        effectiveRate = $('.cri-value[data-div="effective-interest-rate"]').contents().get(0),
        nominalRate = $('.cri-value[data-div="nominal-interest-rate"]').contents().get(0),
        tax = $('.cri-value[data-div="tax"]').contents().get(0),
        totalAmount = $('.cri-value[data-div="total-amount"]').contents().get(0),
        minAmount = parseInt(calcContainer.attr('data-min-amount')),
        maxAmount = parseInt(calcContainer.attr('data-max-amount')),
        timingTable = JSON.parse(calcContainer.attr('data-timing-table')),
        taxPresents = parseInt(calcContainer.attr('data-tax')),
        capitalization = parseInt(calcContainer.attr('data-capitalization')),
        timeInitSingular = calcContainer.attr('data-time-unit-singular'),
        timeInitPlural = calcContainer.attr('data-time-unit-plural'),
        lang = calcContainer.attr('data-lang');

      function calcTotalAmount(effectiveRate, time, amount) {
        return amount*(effectiveRate/100.0*time/12 + 1);
      }
      function calcEffectiveRate(nominalRate, tax) {
        return nominalRate*(100 - tax)/100.0;
      }
      function calcTaxValue(nominalRate, effectiveRate, amount, time) {
        return (nominalRate - effectiveRate)*time/1200*amount;
      }

      var iznos_kamate_umanjen_za_porez;
      function calcTaxValueNew(nominalRate, effectiveRate, amount, time) {

        var averageDaysInMonth = 30.42;
        var currentTimeInDays = parseInt(time * averageDaysInMonth);
        
        // console.log('Iznos: ' + amount);
        // console.log('Vreme: ' + time);
        // console.log('Vreme u danima: ' + currentTimeInDays );
        // console.log('Efektivna kamatna: ' + effectiveRate.toFixed(2));
        // console.log('Nominalna kamatna stopa: ' + nominalRate);

        let result = Math.pow(1 + nominalRate/100, currentTimeInDays/365) - 1;
        // console.log('Konf.koef za br.dana: ' + result);
  
        let kamata =  amount * result;
        // console.log('Kamata (Iznos * Konf): ' + kamata);
  
        let porez = kamata * (taxPresents / 100);
        // console.log('Porez: ' + porez.toFixed(2));
  
        iznos_kamate_umanjen_za_porez = kamata - porez;
        // console.log('Iznos kamate umanjen za porez: ' + iznos_kamate_umanjen_za_porez.toFixed(2));
        // console.log('- - - - - - - - - - - ');

        return porez;
      }

      function calcTotalAmountNew(amount, iznos_kamate_umanjen_za_porez) {
        return amount + iznos_kamate_umanjen_za_porez;
      }

      function calcEffectiveRateWithCapitalization(nominalRate, tax) {
        return (Math.pow(1 + nominalRate/1200, 12)-1)*(100 - tax);
      }
      function addSeparatorsNumber(num, lang) {

        if(num.indexOf('.') === -1) num += '.00';
        var arr = num.toString().split('.');
        var str = "";
        if(arr.length === 2){
          str = addSeparator(arr[0], lang);
          str += '.' + arr[1];
        }
        return str;
      }
      function addSeparator(num, lang) {
        var separator;
        if(lang === 'ru_RU') separator = ' ';
        else separator = ',';
        var str = "";
        var count = 0;
        for(var i = num.length; i > 3; i-= 3, count++){
          str = separator +num.substr(i-3, 3) + str;
        }
        str = num.substr(0, num.length - 3*count) + str;
        return str;
      }

      var currentNominalRate = parseFloat(timingTable[timingTable.length-1]['rate']),
        currentTime = parseInt(timingTable[timingTable.length-1]['time']),
        currentAmount = maxAmount,
        currentEffectiveRate = capitalization === 1?calcEffectiveRateWithCapitalization(currentNominalRate, taxPresents, currentTime):calcEffectiveRate(currentNominalRate, taxPresents),
        // currentTax = calcTaxValue(currentNominalRate, currentEffectiveRate, currentAmount, currentTime),
        // currentTotalAmount = calcTotalAmount(currentEffectiveRate, currentTime, currentAmount);

        currentTax = calcTaxValueNew(currentNominalRate, currentEffectiveRate, currentAmount, currentTime),
        currentTotalAmount = calcTotalAmountNew(currentAmount, iznos_kamate_umanjen_za_porez);


      nominalRate.nodeValue = currentNominalRate.toFixed(2) + ' ';
      effectiveRate.nodeValue = currentEffectiveRate.toFixed(2) + ' ';
      tax.nodeValue = currentTax.toFixed(2) + ' ';
      totalAmount.nodeValue = currentTotalAmount.toFixed(2) + ' ';
      if (currentTime === 1) $('#mobile-mlst-title').text(currentTime + ' ' + timeInitSingular);
      else $('#mobile-mlst-title').text(currentTime + ' ' + timeInitPlural);

      const depositCalc = $('#deposit-calc');
      if (depositCalc.length > 0) {
        const range1 = document.getElementById('range1'),
          range2 = document.getElementById('range2'),
          rangeinputnumber1 = document.getElementById('rangeinputnumber1');
        
        noUiSlider.create(range1, {
          start: [minAmount, maxAmount],
          connect: true,
          range: {
            'min': minAmount,
            'max': maxAmount
          },
          step: 100,
        });

        if(timingTable.length > 1) {
          noUiSlider.create(range2, {
            start: [0, (timingTable.length - 1) * 10],
            connect: true,
            range: {
              'min': 0,
              'max': (timingTable.length - 1) * 10
            },
            step: 10,
          });
        }

        let origins1 = range1.getElementsByClassName('noUi-origin');
        origins1[0].setAttribute('disabled', true);
        if(timingTable.length > 1) {
          let origins2 = range2.getElementsByClassName('noUi-origin');
          origins2[0].setAttribute('disabled', true);
        }

        range1.noUiSlider.on('update', function (values, handle) {
          let value = parseInt(values[handle]);

          if (handle) {
            rangeinputnumber1.value = addSeparator(value.toString(),lang);
          }
          currentAmount = value;
          // currentTax = calcTaxValue(currentNominalRate,currentEffectiveRate, currentAmount, currentTime);
          // currentTotalAmount = calcTotalAmount(currentEffectiveRate, currentTime, currentAmount);

          currentTax = calcTaxValueNew(currentNominalRate, currentEffectiveRate, currentAmount, currentTime);
          currentTotalAmount = calcTotalAmountNew(currentAmount, iznos_kamate_umanjen_za_porez);
          
          tax.nodeValue = addSeparatorsNumber(currentTax.toFixed(2), lang) + ' ';
          totalAmount.nodeValue = addSeparatorsNumber(currentTotalAmount.toFixed(2), lang) + ' ';
        });
        rangeinputnumber1.addEventListener('change', function () {
          range1.noUiSlider.set([null, this.value.replace(/\s|,/g, '')]);
        });
        rangeinputnumber1.addEventListener('input', function () {
          this.value = addSeparator(this.value.replace(/\s|,/g, ''),lang);
        });


        if(timingTable.length > 1) {
          range2.noUiSlider.on('update', function (values, handle) {

            var indexSpan = parseInt(values[handle]) / 10;

            currentNominalRate = parseFloat(timingTable[indexSpan]['rate']);
            currentTime = parseInt(timingTable[indexSpan]['time']);
            currentEffectiveRate = capitalization === 1?calcEffectiveRateWithCapitalization(currentNominalRate, taxPresents, currentTime):calcEffectiveRate(currentNominalRate, taxPresents);
            // currentTax = calcTaxValue(currentNominalRate, currentEffectiveRate, currentAmount, currentTime);
            // currentTotalAmount = calcTotalAmount(currentEffectiveRate, currentTime, currentAmount);

            currentTax = calcTaxValueNew(currentNominalRate, currentEffectiveRate, currentAmount, currentTime),
            currentTotalAmount = calcTotalAmountNew(currentAmount, iznos_kamate_umanjen_za_porez);

            nominalRate.nodeValue = currentNominalRate.toFixed(2) + ' ';
            effectiveRate.nodeValue = currentEffectiveRate.toFixed(2) + ' ';
            tax.nodeValue = addSeparatorsNumber(currentTax.toFixed(2), lang) + ' ';
            totalAmount.nodeValue = addSeparatorsNumber(currentTotalAmount.toFixed(2), lang) + ' ';


            for (let i = 0; i < $('.round-mlst').length; i++) {
              if (i < indexSpan) $('.round-mlst:eq(' + i + ')').addClass('round-mlst-passed').removeClass('round-mlst-active');
              else if (i === indexSpan) $('.round-mlst:eq(' + i + ')').addClass('round-mlst-active');
              else if (i > indexSpan) $('.round-mlst:eq(' + i + ')').removeClass('round-mlst-passed').removeClass('round-mlst-active');
            }

            if (currentTime === 1) $('#mobile-mlst-title').text(currentTime + ' ' + timeInitSingular);
            else $('#mobile-mlst-title').text(currentTime + ' ' + timeInitPlural);

          });
        }

      }
    }
};


// WEBPACK FOOTER //
// ./scripts/routes/pageTemplateDepositPage.js